import { FileClient } from "clients/rest";

export type B100073ExcelRequest = Partial<{
  tokuiCdFrom: string;
  tokuiCdTo: string;
  tokuishitenCdFrom: string;
  tokuishitenCdTo: string;
}>;

export const B100073GetExcel = (props: B100073ExcelRequest) => {
  return FileClient.get("b100073/get/excel", {
    params: props,
  });
};
